<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { TextCardData } from '$lib/api/types';

  export let data: TextCardData;
  export let editable = false;

  const dispatch = createEventDispatcher<{
    change: TextCardData;
  }>();

  let editing = false;
  let editContent = data.content;

  function startEditing() {
    if (!editable) return;
    editContent = data.content;
    editing = true;
  }

  function handleSave() {
    if (editContent !== data.content) {
      dispatch('change', { ...data, content: editContent });
    }
    editing = false;
  }

  function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      editing = false;
    }
  }

  // Style classes based on data
  $: styleClasses = {
    heading: 'text-xl font-bold',
    body: 'text-base',
    quote: 'text-base italic border-l-4 border-gray-300 pl-4',
  }[data.style || 'body'];

  $: sizeClasses = {
    S: 'text-sm',
    M: 'text-base',
    L: 'text-lg',
  }[data.fontSize || 'M'];
</script>

<div
  class="h-full p-4 flex flex-col"
  style:background-color={data.bgColor || undefined}
  style:color={data.textColor || undefined}
>
  {#if editing}
    <textarea
      bind:value={editContent}
      placeholder="テキストを入力"
      class="flex-1 w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none resize-none bg-white text-gray-900 relative z-30"
      on:blur={handleSave}
      on:keydown={handleKeydown}
    />
  {:else}
    <div
      class="flex-1 {styleClasses} {sizeClasses} cursor-text relative z-30"
      on:click={startEditing}
      role={editable ? 'button' : undefined}
      tabindex={editable ? 0 : undefined}
    >
      {#if data.content}
        <p class="whitespace-pre-wrap">{data.content}</p>
      {:else if editable}
        <p class="text-gray-400">クリックして編集</p>
      {/if}
    </div>
  {/if}
</div>
